import { Auth } from "shared/@auth/Auth";
import { useQuery } from "react-query";

export const useActiveTicketsDiamond = (filters) => {
  const { makeAuthedRequest } = Auth.useContainer();

  return useQuery(
    ["activeTicketsDiamond", filters],
    () => {
      const encodedOwners = filters.owners.map(encodeURIComponent).join(";");
      return makeAuthedRequest(
        `v1/reporting/active-tickets-diamond/type/${filters.type}/owner/${
          encodedOwners || null
        }/year/${filters.year}`,
        { method: "GET" }
      ).then((res) => res.json());
    },
    {
      enabled: !!filters,
      staleTime: 0,
      refetchOnWindowFocus: false,
    }
  );
};
